module.exports = __webpack_public_path__ + "img/learn-1-on.542927cb.png";